import { useRef } from 'react';
import { Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication'
import useUserManagement from '../hooks/useUserManagement'
import useTableSlots from '../hooks/useTableSlots'
import useQualityContents from '../hooks/useQualityContents'
import useQaRecordStatuses from '../hooks/useQaRecordStatuses'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const QaRecords = () => {
    useBrowserTabTitle('QA Records')

    const table = useRef(null)
    const localStorageOrderKey = 'tblQaRecordsOrder'
    const localStorageStatusKey = 'tblQaRecordsStatus'
    const defaultOrder = [[ 0, 'desc' ]]
    
    const { currentUser } = useAuthentication()

    const {
        userHasRole,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        qaRecords,
    } = useQualityContents()

    const {
        qaRecordStatuses,
    } = useQaRecordStatuses()

    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'final_version_file_path' },
        { data: 'created_at' },
        { data: 'reference' },
        { data: 'title' },
        { data: 'qa_record_type_name' },
        { data: 'owner_user_id' },
        { data: 'qa_record_status_name' }
    ]

    const tableHead = (
        <tr>
            <th style={{width: '25px'}}>&nbsp;</th>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Type</th>
            <th>Owner</th>
            <th>Status</th>
        </tr>
    )

    const tableSlots = {
        0: filePathSlot,
        1: dateSlot,
        2: (data, type, row) => linkSlot(data, type, row, `/qa_records/${row.id}`),
        3: (data, type, row) => linkSlot(data, type, row, `/qa_records/${row.id}`),
        4: (data, type, row) => {
            if( type !== 'display') {
                return data
            }
            let value = data
            if (row.incorporated_in_projects?.length > 0) {
                value = (
                    <span>{data}
                        <i className="fa fa-share-alt" data-tooltip-id="gnctooltip" data-tooltip-content="Shared Document"></i>
                    </span>
                )
            }
            return value
        },
        5: ownerSlot
    }

    if (!isUserManagementInitialized) {
        return <Loading />
    }
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>QA Records</h2>

                            { userHasRole(currentUser, 'qa_records_user') &&
                                <Link type="button" className="btn btn-mr btn-primary" to="/qa_records/new">New QA Record</Link>
                            }
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="6"
                                    data={qaRecordStatuses}
                                    localStorageKey={localStorageStatusKey}
                                />
                            </div>

                            <GncDataTable
                                    tableRef={table}
                                    data={qaRecords}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default QaRecords
